import { render, staticRenderFns } from "./LicensingDetails.vue?vue&type=template&id=f7817f1c&"
import script from "./LicensingDetails.vue?vue&type=script&lang=js&"
export * from "./LicensingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports